import {JSX, useCallback, useState} from "react";
import {Button, DialogContent, DialogTitle, MobileStepper} from "@mui/material"
import {KeyboardArrowLeft, KeyboardArrowRight} from "@mui/icons-material";

export interface FormStep<T> {
    readonly element: JSX.Element;
    readonly text: string;
    readonly nextEnabled?: (form: T) => boolean;
}

export interface StepFormProps<T> {
    readonly steps: FormStep<T>[]
    readonly form: T
    readonly finishText?: string
    readonly finish: (cancel: boolean) => void
}

export function StepForm<T>(props: StepFormProps<T>) {

    const [activeStep, setActiveStep] = useState(0)

    const backButton = useCallback(() => {

        let text = "Zurück" // "Abbrechen"?
        if (activeStep > 0) {
            text = props.steps[activeStep - 1].text || "Zurück"
        }

        return (
            <Button
                // size="small"
                onClick={() => {
                    if (activeStep === 0) {
                        props.finish(true)
                    } else {
                        setActiveStep(activeStep - 1)
                    }
                }}
            >
                <KeyboardArrowLeft/>
                {text}
            </Button>
        )
    }, [props, activeStep])

    const nextButton = useCallback(() => {

        let currentStep = props.steps[activeStep]

        let text = props.finishText ?? "Abschliessen"
        if (activeStep < (props.steps.length - 1)) {
            text = props.steps[activeStep + 1].text
        }

        let enabled = true
        if (enabled && currentStep.nextEnabled) {
            enabled = currentStep.nextEnabled(props.form)
        }

        return (
            <Button
                // size="small"
                onClick={() => {
                    if (activeStep >= (props.steps.length - 1)) {
                        props.finish(false)
                    } else {
                        setActiveStep(activeStep + 1)
                    }
                }}
                disabled={!enabled}
            >
                {text}
                <KeyboardArrowRight/>
            </Button>
        )
    }, [props.steps, props.form, activeStep])


    return (
        <>
            <MobileStepper
                variant="dots"
                steps={props.steps.length}
                position="static"
                activeStep={activeStep}
                backButton={backButton()}
                nextButton={nextButton()}
            />

            <DialogTitle>
                {props.steps[activeStep].text}
            </DialogTitle>
            <DialogContent>
                {props.steps[activeStep].element}
            </DialogContent>
        </>
    )
}